import React from "react";
import CommonModal from "../CommonModal";
import "./UnapprovedNavigatorModal.css";

const pageList = (pages) => {
  if (pages.length === 1) return `Page ${pages[0]}`;
  return `Pages ${pages.slice(0, -1).join(", ")} and ${pages[pages.length - 1]}`;
};

const UnapprovedNavigatorModal = ({
  pages,
  failures,
  isPublished,
  busy,
  onApproveAndPublish,
  onPublishAnyway,
  onReview,
  onClose,
}) => {
  const publishWord = isPublished ? "republish" : "publish";
  const PublishWord = isPublished ? "Republish" : "Publish";

  return (
    <CommonModal
      title="Some Navigator pages aren't approved"
      modalStatus={true}
      changeActiveStatus={onClose}
      centered
      dialogClassName="unapproved-nav-dialog"
      closeModalOnEsc={!busy}
      hideCloseIcon={busy}
      footer={
        <div className="unapproved-nav__actions">
          <button
            type="button"
            className="unapproved-nav__primary"
            onClick={() => onReview(failures?.[0]?.page ?? pages[0])}
            disabled={busy}
          >
            Review pages
          </button>
          <div className="unapproved-nav__secondary">
            <button
              type="button"
              className="unapproved-nav__link"
              onClick={onApproveAndPublish}
              disabled={busy}
            >
              {busy ? "Approving…" : `Approve all & ${publishWord}`}
            </button>
            <button
              type="button"
              className="unapproved-nav__link"
              onClick={onPublishAnyway}
              disabled={busy}
            >
              {PublishWord} anyway
            </button>
          </div>
        </div>
      }
    >
      <p className="mb-0">
        {pageList(pages)} {pages.length === 1 ? "has" : "have"} unapproved Navigator changes.
        Viewers won't see them until they're approved.
      </p>
      {failures?.length > 0 && (
        <div className="unapproved-nav__fail">
          Nothing was {isPublished ? "republished" : "published"}. Couldn't approve:
          <ul>
            {failures.map(({ page, error }) => (
              <li key={page}>
                <button type="button" className="unapproved-nav__link" onClick={() => onReview(page)}>
                  Page {page}
                </button>
                : {error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </CommonModal>
  );
};

export default UnapprovedNavigatorModal;
